import { ssoRequest } from '@services/index'
import { workWechatJsApi as wx } from '../index'
import { wxworkGE3_0_24 } from './utils'
import { Notify } from 'vant'
import { renderDTOpenData } from '@utils/basicUtil'

/**
 * 调用 wx.config
 *
 * @see https://open.work.weixin.qq.com/api/doc/90001/90144/90547
 */
 const config = async function (_config) {
  return new Promise((resolve, reject) => {
      console.info('wx.config', _config)
      wx.config(_config)
      wx.ready(resolve)
      wx.error(reject)
  }).then(() => {
      console.info('wx.ready')
  }, error => {
      console.error('wx.error', error)
      throw error
  })
}


/**
 * 调用 wx.agentConfig
 *
 * @see https://open.work.weixin.qq.com/api/doc/90001/90144/90548
 */
const agentConfig = async function (_config) {
  return new Promise((success, fail) => {
      console.info('wx.agentConfig', _config)
      wx.agentConfig({ ..._config, success, fail })
  }).then(res => {
      console.info('wx.agentConfig success', res)
      return res
  }, error => {
      console.error('wx.agentConfig fail', error)
      throw error
  })
}

//所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用（同一个url仅需调用一次，对于变化url的SPA（single-page application）的web app可在每次url变化时进行调用）。

const configAuth = async () => {
  // 调用config
  //url（当前网页的URL， 不包含#及其后面部分）
  let url = `${window.location.protocol}//${window.location.host}/user-center/index`
  const result = await ssoRequest.workWechat.getConfig({url})
  if (result.success) {
    if (result.result) {
      const params = {
        beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: result.result.appId, // 必填，企业微信的corpID
        timestamp: result.result.timeStamp, // 必填，生成签名的时间戳
        nonceStr: result.result.nonceStr, // 必填，生成签名的随机串
        signature: result.result.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: [
          "onHistoryBack",
          "scanQRCode",
          "invoke",
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "onMenuShareQZone",
          "startRecord",
          "stopRecord",
          "onVoiceRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "onVoicePlayEnd",
          "uploadVoice",
          "downloadVoice",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "translateVoice",
          "getNetworkType",
          "openLocation",
          "getLocation",
          "hideOptionMenu",
          "showOptionMenu",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "addCard",
          "chooseCard",
          "openCard"
        ] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      }
      await config(params)
    }
  } else {
    if (result.message) {
      Notify({ type: 'danger', message: result.message })
    }
  }
}

const agentConfigAuth = async () => {
  let url = `${window.location.protocol}//${window.location.host}/user-center/index`
  const result = await ssoRequest.workWechat.getAgentConfig({url})
  if (result.success) {
    if (result.result) {
      const params = {
        corpid: result.result.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid: result.result.agentId, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp: result.result.timeStamp, // 必填，生成签名的时间戳
        nonceStr: result.result.nonceStr, // 必填，生成签名的随机串
        signature: result.result.signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: [], //必填，传入需要使用的接口名称
      }
      await agentConfig(params)
    }
  } else {
    if (result.message) {
      Notify({ type: 'danger', message: result.message })
    }
  }
}

const auth = async () => {
  const ge3_0_24Res = wxworkGE3_0_24()
  // 如果是企微并且大于3.0.24, 直接使用 agentConfig
  if (ge3_0_24Res.isWxwork && ge3_0_24Res.ge3_0_24) {
    //注意：在企业微信客户端的页面上，进行 agentConfig 的调用，必须要等 wx.config 完成后才调用（即 wx.config 的成功回调）
    await configAuth()
    await agentConfigAuth()
    renderDTOpenData()
  }
}

export default {
  configAuth,
  agentConfigAuth,
  auth
}
